<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <div style="white-space:nowrap;margin-left: 10px;margin-right: 5px;">搜索</div>
                <el-input placeholder="输入关键字" v-model="condition" clearable>
                </el-input>
              </div>
            </el-row>
            <el-row>
              <el-button type="primary" round @click="editDialogVisible=true">添加</el-button>
              <el-button type="danger" round @click="deleteSelectedCourses">删除</el-button>
            </el-row>
          </div>
        </div>

        <div style="padding: 10px;">
          <div style="padding: 5px;color: red;font-size:14px;">
            需新增科目点右侧的"添加"按钮;如需修改,删掉不用的科目,重新添加。</div>
          <el-table ref="multipleTable" :data="filterData" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            style="width: 100%" @sort-change="changeSort" highlight-current-row>
            <el-table-column align="center" label="选择" type="selection" width="55">
            </el-table-column>
            <el-table-column type="index" label="序号" width="100" :index="indexMethod">
            </el-table-column>
            <el-table-column prop="course_name" label="名称">
            </el-table-column>
           <el-table-column label="数据是那种类型?">
              <template slot-scope="scope">
                <span v-if="scope.row.is_score === 1">数字类成绩</span>
                <span v-else>成绩评级、成绩排名或文字等</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="300">
              <template slot-scope="scope">
                <el-button @click.native.prevent="upgrade(scope.$index, filterData)" type="text" size="small">
                  ↑上移
                </el-button>
                <el-button @click.native.prevent="downgrade(scope.$index, filterData)" type="text" size="small">
                  ↓下移
                </el-button>
                <el-button @click.native.prevent="delCourse(scope.$index, filterData)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

      </el-col>
    </el-row>

    <el-dialog title="添加新科目" :visible.sync="editDialogVisible"  width="40%">
      <el-form :model="form">
        <el-form-item label="科目名称" :label-width="formLabelWidth">
          <el-input v-model="form.course_name" autocomplete="off" placeholder="输入科目名称"></el-input>
        </el-form-item>
       <el-form-item label="数据类型" :label-width="formLabelWidth">
          <el-radio-group v-model="form.course_type" size="mini">
            <el-radio label="1" style="margin-bottom: 20px;margin-top: 15px;">录入的是数字类成绩,如分数</el-radio>
            <el-radio label="0" style="margin-bottom: 20px;">录入的是成绩评级或不是成绩,如名次、评语等</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCourseSave">保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.examID = this.$route.params.id
      // console.log('传递过来的参数是:' + this.examID)
      this.username = this.$session.get('USERNAME') // 获取session
      this.loadData('', '')
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      console.log('student_ist:' + this.username)
      // this.setCurrent(this.new_position)
    },
    watch: {
      filterData(val, oldVal) { // 普通的watch监听
        if (this.show_selection === true) {
          this.setCurrent(this.filterData[this.new_position])
        }
      }
    },
    // 搜索数据
    computed: {
      filterData: function() {
        let that = this
        var input = this.condition && this.condition.toLowerCase()
        var items = this.tableData
        var items1
        if (input) {
          items1 = items.filter(function(item) {
            return Object.keys(item).some(function(key1) {
              return String(item[key1])
                .toLowerCase()
                .match(input)
            })
          })
        } else {
          items1 = items
        }
        that.currentItems = items1

        return items1
      }
    },
    data() {
      return {
        username: '',
        condition: '',
        examID: '',
        tableData: [],
        currentItems: [],
        dialogVisible: false,
        editDialogVisible: false,
        msg: '',
        selectedID: '',
        position: -1,
        form: {
          course_name: '',
          id: '',
          course_type: ''
        },
        formLabelWidth: '80px',
        systemCourses: [],
        new_position: 0,
        show_selection: false
      }
    },
    methods: {

      loadData(sortFieldName, sortType) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_get_custom_courses.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      addCourseSave() {
        // 校验数据
        if (this.form.course_name === '') {
          this.$message.error('请输入科目名称')
          return
        }

        if (this.form.course_type === '') {
          this.$message.error('请选择科目类型')
          return
        }

        let that = this

        var requestUrl = '/score/web/_add_course.jsp'
        this.axios.get(requestUrl, {
            params: {
              course_name: that.form.course_name,
              course_type: that.form.course_type,
              username: that.username
            }
          }).then(function(response) {
            // 更新表格的数据
            that.loadData('', '')
            that.editDialogVisible = false

            if (response.data.result === '-1') {
              that.$message.error('"' + that.form.course_name + '"已经存在！')
            } else if (response.data.result === '-2') {
              that.$message.error('"' + that.form.course_name + '"在系统中存在，无须重复添加！')
            } else {
              that.$message.success('添加成功！')
              that.show_selection = true
              that.new_position = that.tableData.length
            }

            that.form.course_name = ''
          })
          .catch(function(error) {
            console.log(error)
            that.$message(error)
            that.editDialogVisible = false
          })
      },
      // 从后台获取数据,重新排序
      changeSort(val) {
        console.log(val) // column: {…} order: "ascending" prop: "date"
        // 根据当前排序重新获取后台数据,一般后台会需要一个排序的参数
        // this.loadData(val.prop, val.order)
      },
      delCourse(index, rows) {
        let that = this
        this.show_selection = false

        this.selectedID = this.currentItems[index].id

        console.log('this.selectedID=' + this.selectedID)

        this.position = index

        this.msg = '删除后在成绩导入时看不到该科目名称,要删除"' + this.currentItems[index].course_name + '"吗？'
        let courseName = this.currentItems[index].course_name

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/score/web/_delete_course.jsp'
          this.axios.get(requestUrl, {
              params: {
                course_name: courseName,
                username: that.username
              }
            }).then(function(response) {
              that.loadData()

              that.$message.success('删除成功！')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      indexMethod(index) {
        return index + 1
      },
      indexSysMethod(index) {
        return index + 1
      },
      setCurrent(row) {
        this.$refs.multipleTable.setCurrentRow(row)
      },
      upgrade(index, rows) {
        let courseName = rows[index].course_name
        let that = this

        this.show_selection = true

        this.new_position = index
        if (index > 0) {
          this.new_position = index - 1
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_move_course_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              course: courseName,
              direction: 'UPGRADE'
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      downgrade(index, rows) {
        let courseName = rows[index].course_name
        let that = this

        this.show_selection = true

        this.new_position = index
        if (index < this.currentItems.length - 1) {
          this.new_position = index + 1
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_move_course_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              course: courseName,
              direction: 'DOWNGRADE'
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      deleteSelectedCourses() {
        let that = this
        let courses = this.$refs.multipleTable.selection
        let coursesJsonStr = JSON.stringify(courses)

        this.msg = '要删除选中的科目名称吗？'

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            courses: coursesJsonStr,
            username: that.username
          }

          that.show_selection = false

          var qs = require('qs')

          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_delete_muti_courses.jsp'

          this.axios.post(
              requestUrl,
              qs.stringify(data), {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            ).then(function(response) {
              that.loadData('', '')
              load.close()
            })
            .catch(function(error) {
              console.log(error)
              load.close()
            })
        })
      }
    }
  }
</script>

<style>
  .searchStyle {
    display: flex;
    width: 200px;
    align-items: center;

  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/courses_list.vue